import React from 'react';
import { BellIcon, ClockIcon, CalendarIcon, UserIcon, SparklesIcon } from 'lucide-react';
export const NotificationStrategySlide = () => {
  return <div className="p-8 md:p-16 min-h-[600px] bg-white" data-id="element-664">
      <h2 className="text-2xl md:text-3xl font-light text-[#333333] mb-5 border-l-4 border-[#d4af37] pl-4" data-id="element-665">
        Notificaties: De Eerste Gamification-Laag
      </h2>
      <div className="flex items-center mb-5" data-id="element-666">
        <BellIcon className="w-5 h-5 text-[#d4af37] mr-3" data-id="element-667" />
        <p className="text-[#666666] text-sm leading-relaxed" data-id="element-668">
          Mosy's notificaties zijn zorgvuldig ontworpen als subtiele
          gamification-elementen die gebruikers motiveren op basis van hun eigen
          gedrag en patronen.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5" data-id="element-669">
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm transition-all hover:shadow-md" data-id="element-670">
          <h3 className="text-xl font-light text-[#333333] mb-3" data-id="element-671">
            Context-Gedreven Benadering
          </h3>
          <div className="space-y-3" data-id="element-672">
            <div className="flex items-start" data-id="element-673">
              <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 mt-1" data-id="element-674">
                <ClockIcon className="h-4 w-4 text-[#d4af37]" data-id="element-675" />
              </div>
              <div data-id="element-676">
                <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-677">
                  Tijdgebaseerd
                </p>
                <p className="text-xs text-[#666666] leading-relaxed" data-id="element-678">
                  "Je checkt meestal rond 20:30 in — zullen we dat nu doen?"
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-679">
              <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 mt-1" data-id="element-680">
                <UserIcon className="h-4 w-4 text-[#d4af37]" data-id="element-681" />
              </div>
              <div data-id="element-682">
                <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-683">
                  Patroongebaseerd
                </p>
                <p className="text-xs text-[#666666] leading-relaxed" data-id="element-684">
                  "Je voelt je vaak kalmer na avondoefeningen. Er is een nieuwe
                  beschikbaar."
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-685">
              <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 mt-1" data-id="element-686">
                <CalendarIcon className="h-4 w-4 text-[#d4af37]" data-id="element-687" />
              </div>
              <div data-id="element-688">
                <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-689">
                  Voortgangsgebaseerd
                </p>
                <p className="text-xs text-[#666666] leading-relaxed" data-id="element-690">
                  "Nog één check-in voor je weekbalans mijlpaal. Je bent er
                  bijna."
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm transition-all hover:shadow-md" data-id="element-691">
          <h3 className="text-xl font-light text-[#333333] mb-3" data-id="element-692">
            Gamification-Principes
          </h3>
          <div className="mb-3" data-id="element-693">
            <p className="text-sm text-[#666666] mb-3 leading-relaxed" data-id="element-694">
              Subtiele gamification-technieken in notificaties:
            </p>
            <div className="space-y-2 mb-3" data-id="element-695">
              <div className="flex items-start" data-id="element-696">
                <div className="w-3 h-3 rounded-full bg-[#d4af37] opacity-40 mt-1 mr-2" data-id="element-697"></div>
                <p className="text-xs text-[#666666]" data-id="element-698">
                  <span className="font-medium" data-id="element-699">Progressie-indicatoren</span>:
                  "Nog één check-in voor je mijlpaal"
                </p>
              </div>
              <div className="flex items-start" data-id="element-700">
                <div className="w-3 h-3 rounded-full bg-[#d4af37] opacity-40 mt-1 mr-2" data-id="element-701"></div>
                <p className="text-xs text-[#666666]" data-id="element-702">
                  <span className="font-medium" data-id="element-703">Streaks & reeksen</span>: "Je
                  balansreeks staat op dag 4"
                </p>
              </div>
              <div className="flex items-start" data-id="element-704">
                <div className="w-3 h-3 rounded-full bg-[#d4af37] opacity-40 mt-1 mr-2" data-id="element-705"></div>
                <p className="text-xs text-[#666666]" data-id="element-706">
                  <span className="font-medium" data-id="element-707">Beloningsaankondigingen</span>:
                  "Bijna een nieuwe functie vrijgespeeld"
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-708">
            <div className="flex items-start" data-id="element-709">
              <SparklesIcon className="w-4 h-4 text-[#d4af37] mr-2 mt-0.5 flex-shrink-0" data-id="element-710" />
              <p className="text-xs text-[#666666] italic leading-relaxed" data-id="element-711">
                Notificaties zijn subtiel ontworpen om gebruikers terug te
                brengen naar de app zonder opdringerig te zijn, en vormen de
                basis voor diepere engagement-elementen.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#f7f3ef] p-4 rounded-lg" data-id="element-712">
        <h3 className="text-lg font-light text-[#333333] mb-3 text-center" data-id="element-713">
          Nieuwe Notificatie-Innovaties
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-714">
          <div className="bg-white p-3 rounded-lg" data-id="element-715">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-716">
              Dynamische Timing
            </p>
            <p className="text-xs text-[#666666]" data-id="element-717">
              Notificaties worden verzonden op optimale momenten gebaseerd op
              gebruikersgedrag
            </p>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-718">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-719">
              Positieve Framing
            </p>
            <p className="text-xs text-[#666666]" data-id="element-720">
              Focus op wat bereikt is in plaats van wat gemist is
            </p>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-721">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-722">
              Gecontextualiseerde Content
            </p>
            <p className="text-xs text-[#666666]" data-id="element-723">
              Notificaties die aansluiten bij gebruikers' huidige mentale
              gezondheidstraject
            </p>
          </div>
        </div>
      </div>
    </div>;
};